import React, { useRef, useState } from 'react';
import CompGridMatchDtl from '@components/grid/comp-grid-matchdtl.js';
import CompFormMatchDtl from '@components/form/comp-form-matchdtl.js';
import SearchForm from '@components/form/fragment/comp-fmt-search.js';
import ButtonForm from '@components/form/fragment/comp-fmt-button.js';
import {removeGrid} from '@assets/js/api/commonApi.js';

const MatchDtlMng = (props) => {
    /****************************
     * Define required variables
     *****************************/
    const childRef = useRef();
    const childGridRef = useRef();
    const [params, setParams] = useState({});
    const [selectedRows, setSelectedRows] = useState([]);

    /**************************
     * Define button functions
     ***************************/
    const onModify = (params) => {
        childRef.current.modalToggle({mode: 'M', ...params});
    }
    // const onRemove = () => {
    //     if (selectedRows.length === 0) { alert('1건이상 선택해주세요.'); return; }
    //     const idsArray = [...selectedRows.ids];
    //     if (idsArray.length === 0) {
    //         alert('삭제할 항목을 선택해주세요.');
    //         return;
    //     }

    //     const deleteParams = {
    //         deleteList: idsArray.map(rowId => {
    //             // rowId format: mngCd|mtmkgCd|armType|plyrCd
    //             const [mngCd, mtmkgCd, armType, plyrCd] = rowId.split('|');
    //             return {
    //                 mngCd: mngCd,
    //                 mtmkgCd: mtmkgCd,
    //                 armType: armType,
    //                 plyrCd: plyrCd
    //             };
    //         })
    //     };

    //     removeGrid('/sys/matchdtlmng/remove/info', deleteParams, {
    //         msg: {
    //             confirm: '선택된 ' + idsArray.length + '개 항목을 삭제하시겠습니까?',
    //         }
    //     }).then(res => {
    //         if (res && res.success) {
    //             //clear selected rows grid.
    //             setSelectedRows(new Set());
    //             onGridSearch();
    //         }
    //     });
    // }
    const onGridSearch = () => {
        childGridRef.current.onGridSearch(params);
    }
    const onValChange = (e) => {
        const { id, value } = e.target;
        // Update the state with the new value
        setParams({ ...params, [id]: value });
    }

    /****************************
     * Define form config
     *****************************/
    const formObj = {
        id : 'searchForm',
        params : {
            comptnCd : {
                id: 'comptnNm',
                label: '대회명',
                maxLength : 10,
            },
        }
    }
    const buttonConfig = {
        leftButtons: [
        ],
        rightButtons: [
            { id: 'search', label: 'Search', className: 'btn-primary', onClick: onGridSearch }
        ]
    }

    return (
        <>
            {/* SearchForm */}
            <SearchForm formObj={formObj} onValChange={onValChange} onGridSearch={onGridSearch} params={params}/>

            {/* ButtonForm */}
            <ButtonForm buttonConfig={buttonConfig} />

            {/* Grid */}
            <CompGridMatchDtl ref={childGridRef} onChildClick={onModify} onSelectionChange={setSelectedRows} />

            {/* Modal popup */}
            <CompFormMatchDtl ref={childRef} onGridSearch={onGridSearch} />
        </>
    );
}

export default MatchDtlMng;
